import { apiFetch } from "./client";
import type { components } from "./schema";

export type MeUpdate = components["schemas"]["MeUpdate"];
export type Municipality = components["schemas"]["Municipality"];
export type Profile = components["schemas"]["Profile"];
export type Transport = components["schemas"]["Transport"];
type Me = components["schemas"]["Me"];

export function updateMe(patch: MeUpdate): Promise<Me> {
  return apiFetch<Me>("/me", { method: "PATCH", json: patch });
}

export async function searchMunicipalities(q: string): Promise<Municipality[]> {
  const body = await apiFetch<components["schemas"]["MunicipalityList"]>(
    `/municipalities?${new URLSearchParams({ q, limit: "8" }).toString()}`,
  );
  return body.items;
}

export async function newRecoveryCodes(): Promise<string[]> {
  const body = await apiFetch<components["schemas"]["RecoveryCodes"]>("/me/recovery-codes", { method: "POST" });
  return body.recovery_codes;
}

/** Irreversible: the own school address must be typed again. */
export function deleteMe(confirmEmail: string): Promise<void> {
  return apiFetch<undefined>("/me", { method: "DELETE", json: { confirm_email: confirmEmail } });
}
